<template>
  <div class="row mx-0">
    <footer class="col-12 px-5 py-4 font-weight-bold text-center custom-footer-two" v-bind:style="{backgroundColor: this.settings_style.colors != undefined ? this.settings_style.colors[0].color_value : 'white'}">
      <span v-if="quote_data != undefined">{{quote_data.owner.company}}</span>
      <span v-else>Nombre de la empresa</span>
    </footer>
  </div>
</template>
<script>
export default {
  props: {
    settings_style: {
      required: true,
    },
    quote_data: {
      type: Object,
    },
  },
};
</script>